// src/pages/geral/UsuarioSearch.js
import React, { useEffect, useState, useRef } from 'react';
import { FaSortUp, FaSortDown } from "react-icons/fa";

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalTable from '../../components/modalForm/ModalTable';
import LazyLoading from '../../components/modalForm/LazyLoading';
import { useUsuario } from '../../contexts/geral/UsuarioContext';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const UsuarioSearch = ({ show, onHide, onSelectUsuario }) => {
    const { usuarios } = useUsuario();
    const [filter, setFilter] = useState('');

    const [sortField, setSortField] = useState('id');
    const [sortDirection, setSortDirection] = useState('asc');

    const inputRef = useRef(null);

    useEffect(() => {
        if (show) {
            setFilter('');

            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    }, [show]);

    if (!show) return null;

    const filteredUsuarios = usuarios.filter(usuario =>
        usuario?.nome.toLowerCase().includes(filter.toLowerCase())
    );

    const sortedUsuarios = filteredUsuarios.sort((a, b) => {
        if (sortField === 'id') {
            return sortDirection === 'asc' ? a.id - b.id : b.id - a.id;
        } else if (sortField === 'nome') {
            const nomeA = a.nome.toLowerCase();
            const nomeB = b.nome.toLowerCase();
            if (nomeA < nomeB) return sortDirection === 'asc' ? -1 : 1;
            if (nomeA > nomeB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        } else if (sortField === 'email') {
            const emailA = a.email.toLowerCase();
            const emailB = b.email.toLowerCase();
            if (emailA < emailB) return sortDirection === 'asc' ? -1 : 1;
            if (emailA > emailB) return sortDirection === 'asc' ? 1 : -1;
            return 0;
        }
        return 0;
    });

    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('asc');
        }
    };

    const handleDoubleClick = (usuario) => {
        onSelectUsuario(usuario);
        onHide();
    };

    return (
        <ModalContainer show={show} largura='600px' variant="busca" onHide={onHide}>
            <ModalHeader title="Buscar Usuário" onHide={onHide} />
            <ModalBody>
                <div className="mb-3">
                    <ModalSearchBar
                        inputRef={inputRef}
                        type="text"

                        placeholder="Filtrar por nome..."
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
                <LazyLoading items={sortedUsuarios} resetKey={JSON.stringify([show, filter, sortField, sortDirection])}>
                {({ containerRef, handleScroll, visibleItems }) => (
                <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
                    <thead>
                        <tr>
                            <th className="text-center align-middle" scope="col" style={{ width: '10%' }} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Id
                                    {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '35%' }} aria-sort={sortField === 'nome' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('nome')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Nome
                                    {sortField === 'nome' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-start align-middle" scope="col" style={{ width: '35%' }} aria-sort={sortField === 'email' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                <button onClick={() => handleSort('email')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0} type="button">
                                    Email
                                    {sortField === 'email' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                                </button>
                            </th>
                            <th className="text-center align-middle modal-select-column" scope="col" style={{ width: '20%' }}>Selecionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {visibleItems.map((usuario) => (
                            <tr key={usuario.id} onDoubleClick={() => handleDoubleClick(usuario)}>
                                <td className="text-end align-middle">{usuario.id}</td>
                                <td className="text-start align-middle">{usuario?.nome}</td>
                                <td className="text-start align-middle">{usuario?.email}</td>
                                <td className="text-center align-middle modal-select-column">
                                    <ModalSelectButton className="btn btn-outline-secondary btn-sm" onClick={() => onSelectUsuario(usuario)} style={{ padding: '2px 6px' }} label={usuario?.nome} />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </ModalTable>
                )}
                </LazyLoading>
            </ModalBody>
            <ModalFooter>

                <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">
                    Fechar
                </ModalActionButton>
            </ModalFooter>
        </ModalContainer>
    );
};

export default UsuarioSearch;